import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { env } from 'config/environment'
import { observer } from 'mobx-react-lite'
import LogoDresscodeSvg from './logo-dresscode.svg'
import LogoShowoffSvg from './logo-showoff.svg'
import css from './ShopLogo2.module.scss'

type Props = {
  logo: string | undefined
}

export const ShopLogo2 = observer(({ logo }: Props) => {
  const className = clsx(css.logo)
  const dresscode = env.domain === 'dresscode'

  return <Space className={className}>
    {logo ? <Image src={logo} /> : dresscode ? <LogoDresscodeSvg /> : <LogoShowoffSvg />}
  </Space>
})
